import { useMemo } from 'react'
import { WbsItemTypeVO } from '../../../../../../../domain/value-object/WbsItemTypeVO'
import { TicketListSelectRow } from '../model'

export type TicketListGroup = {
  ticketType: string
  typeName: string
  iconUrl?: string
  items: TicketListSelectRow[]
}

export const useTicketListGroups = (
  rows: TicketListSelectRow[],
  searchText: string,
  ticketTypes: WbsItemTypeVO[]
): TicketListGroup[] => {
  return useMemo(() => {
    const typeByCode = new Map(ticketTypes.map(type => [type.code, type]))
    const normalizedSearchText = searchText.trim().toLowerCase()

    const rowsByTicketType = new Map<string, TicketListSelectRow[]>()
    for (const row of rows) {
      const items = rowsByTicketType.get(row.ticketType) ?? []
      items.push(row)
      rowsByTicketType.set(row.ticketType, items)
    }

    const groups: TicketListGroup[] = []
    for (const [ticketType, items] of rowsByTicketType) {
      const typeVO = typeByCode.get(ticketType)
      const typeName = typeVO?.name ?? ticketType

      // タイプ名にマッチした場合はグループ内の全インスタンスを表示、
      // マッチしない場合はインスタンス名でマッチしたものだけに絞り込む
      const matchedItems = !normalizedSearchText
        ? items
        : typeName.toLowerCase().includes(normalizedSearchText)
          ? items
          : items.filter(item =>
              item.displayName.toLowerCase().includes(normalizedSearchText)
            )

      if (matchedItems.length === 0) continue

      groups.push({
        ticketType,
        typeName,
        iconUrl: typeVO?.iconUrl,
        items: matchedItems,
      })
    }
    return groups
  }, [rows, searchText, ticketTypes])
}
